// extracted by mini-css-extract-plugin
export var isLink = "gG_b32";
export var logo = "gG_b22";
export var logo_pic = "gG_b12";